import { ChevronDown } from 'lucide-react';
import PropTypes from 'prop-types';
import React from 'react';
import './StripeSelect.css';

const StripeSelect = ({
  options = [],
  value,
  onChange,
  placeholder,
  label,
  error,
  disabled = false,
  required = false,
  fullWidth = false,
  className = '',
  selectClassName = '',
  ...props
}) => {
  const id = React.useId();

  const containerClassNames = [
    'stripe-form-group',
    fullWidth && 'stripe-form-group-full-width',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const selectClassNames = [
    'stripe-form-select',
    error && 'stripe-form-select-error',
    selectClassName,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={containerClassNames}>
      {label && (
        <label htmlFor={id} className="stripe-form-label">
          {label}
          {required && <span className="stripe-required">*</span>}
        </label>
      )}
      <div className="stripe-select-wrapper">
        <select
          id={id}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={selectClassNames}
          aria-describedby={error ? `${id}-error` : undefined}
          aria-invalid={error ? 'true' : undefined}
          {...props}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <ChevronDown className="stripe-select-icon" size={16} />
      </div>
      {error && (
        <span id={`${id}-error`} className="stripe-form-error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
};

StripeSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
  selectClassName: PropTypes.string,
};

export default StripeSelect;

